"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeavrTransactionTypesEnum = void 0;
var WeavrTransactionTypesEnum;
(function (WeavrTransactionTypesEnum) {
    WeavrTransactionTypesEnum["TRANSFER"] = "TRANSFER";
    WeavrTransactionTypesEnum["AUTHORISATION"] = "AUTHORISATION";
    WeavrTransactionTypesEnum["SETTLEMENT"] = "SETTLEMENT";
    WeavrTransactionTypesEnum["DEPOSIT"] = "DEPOSIT";
    WeavrTransactionTypesEnum["ADJUSTMENT"] = "ADJUSTMENT";
    WeavrTransactionTypesEnum["MANUAL_TRANSACTION"] = "MANUAL_TRANSACTION";
    WeavrTransactionTypesEnum["MERCHANT_REFUND"] = "MERCHANT_REFUND";
    WeavrTransactionTypesEnum["OUTGOING_WIRE_TRANSFER"] = "OUTGOING_WIRE_TRANSFER";
    WeavrTransactionTypesEnum["PURCHASE_REVERSAL"] = "PURCHASE_REVERSAL";
    WeavrTransactionTypesEnum["SETTLEMENT_REVERSAL"] = "SETTLEMENT_REVERSAL";
})(WeavrTransactionTypesEnum || (exports.WeavrTransactionTypesEnum = WeavrTransactionTypesEnum = {}));
